import React from 'react';
import { useBemCN } from '@gik/core/utils/bemBlock';

export interface IGenericTableColumn<T extends Object> {
  // FIXME: these need to match the table typings
  Header: string;
  accessor?: Extract<keyof T, string>;
}

export interface IDataCardProps<T extends object> {
  className: string;
  data: T;
  columns: IGenericTableColumn<T>[];
}

export function DataCard<T extends object>({
  className,
  data,
  columns,
  ...otherProps
}: IDataCardProps<T>): React.ReactElement {
  const bem = useBemCN('data-card');

  return (
    <div {...bem(null, null, className)} {...otherProps}>
      {columns.map(col => (
        <div key={col.accessor} {...bem('row')}>
          <span {...bem('th')}>{col.Header}</span>
          <span {...bem('td')}>{data[col.accessor]}</span>
        </div>
      ))}
    </div>
  );
}
